<template>
  <div id="app">
	<navigation>
    	<router-view></router-view>
	</navigation>
  </div>
</template>

<script>
import Vue from "vue";
import { getCookie, setCookie, parseUrlQuery } from "./common/function";
import axios from "axios";
import md5 from "md5";
export default {
  name: "app",
  data() {
    return {};
  },
  methods: {
    checkLogin() {
      const uidCookieName = "uid";
      const uid = getCookie(uidCookieName);
      if (uid) {
        this.$userInfo.isLogin = true;
        this.$userInfo.userId = uid;
      }
    },
    //如果是在微信环境，则会自动登录。user_uid这个cookie，是判断是否应该执行这个自动登录的flag
    weixinAutoLogin() {
      let canAuto = !this.$userInfo.isLogin && !getCookie("user_uid");
      if (canAuto) {
        window.location.href = `https://www.jingzhi5.com/novel/v2/User/wxLogin.php?backurl=${encodeURIComponent(
          window.location.href
        )}`;
      }
    },
    storeIndexUrl() {
      let originIndex = `${location.protocol}//${location.host}`;
      setCookie('originurl', originIndex);
    }
  },
  created() {
    this.checkLogin();
    this.storeIndexUrl();
    this.$nextTick(() => {
      if (this.$userInfo.isWeiXin) {
        this.weixinAutoLogin();
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue